module.exports = __webpack_public_path__ + "img/nxin-live.3f3346b3.gif";